// Axios
import Axios from "config/axiosConfig";

// Globals
import { api_url } from 'config/GlobalData';

export const GetTeamsApi = () => {
    return Axios.instance.get( `${ api_url }/teams/`,
        {
            headers: {
                'Authorization': localStorage.getTeams('token')
            }
        }
    );
}

export const GetCountryApi = () => {

    return Axios.instance.get(`${api_url}/country-gateway/`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const GetCountryIdApi = (owner_id) => {

    return Axios.instance.get(`${api_url}/country-gateway/?search=${owner_id}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const GetPaymantesFormTemplateIdApi = ( form_type, owner_id ) => {

    return Axios.instance.get(`${api_url}/forms-template/?form_type=${form_type}&owner_id=${owner_id}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const GetCountryStatesApi = (country) => {
    return Axios.instance.get(`${api_url}/states/?country=${country}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const GetGatewayAttributeApi = (country_gateway_id, question_type) => {
    return Axios.instance.get(`${api_url}/gateway-attribute/?country_gateway=${country_gateway_id}&question_type=${question_type}`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const getPagePaymentsApi = (pagename, filter = '') => {
    return Axios.instance.get(`${api_url}/leagues/${pagename}/payments/?state=${filter}&page_size=50`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const getPaymentDetailApi = ( page_payment_id ) => {
    return Axios.instance.get(`${api_url}/page-payments/${page_payment_id}/`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const getPaymentReceiptApi = ( page_payment_id ) => {
    return Axios.instance.get(`${api_url}/hub-page-payments/${page_payment_id}/`,
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}

export const getPaymentUrlApi = ( page_payment_section_id, redirect_url ) => {
    return Axios.instance.post(`${api_url}/page-payments-section/${page_payment_section_id}/checkout/`,
        {
            redirect_url: redirect_url,
            mobile: false
        },
        {
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        }
    );
}
